import './TWInput.scss'
import { classify, uid } from "../../../helpers"

const TWInput = ({
	dark,
	name,
	label,
	textarea,
	helpText,
	id = uid(),
	errors = [],
	value = '',
	helpClass = '',
	inputClass = '',
	labelClass = '',
	contentClass = '',
	type = 'text',
	className = '',
	hint = 'Enter input here',
	onChange
}) => {

	const error = errors.length ? errors[0].replace('{field}', name) : null

	return (
		<div className={classify('tw-input flex flex-col md:flex-row', className, { error })}>
			<label
				htmlFor="id"
				className={classify("text-base md:text-xl font-light md:font-bold pt-2 flex-shrink-0", labelClass)}
			>{label || name}</label
			>
			<div className={classify("md:ml-6", contentClass)}>
				{textarea
					? <textarea
						id={id}
						type={type}
						name={name}
						value={value}
						placeholder={hint}
						className={classify(
							inputClass,
							'text-base md:text-xl py-1 px-2 md:py-2 md:px-3 text-white', {
							dark, 'border border-red-500': error
						})}
						onChange={e => onChange && onChange(e.target.value)}
					/>
					: <input
						id={id}
						type={type}
						name={name}
						value={value}
						placeholder={hint}
						className={classify(
							inputClass,
							'text-base md:text-xl py-1 px-2 md:py-2 md:px-3 text-white', {
							dark, 'border border-red-500': error
						})}
						onChange={e => onChange && onChange(e.target.value)}
					/>
				}

				<small className={classify("block text-base mt-1 text-gray-300", helpClass)}>
					{helpText}
				</small>
				{error && <p className="text-red-500">{error}</p>}
			</div>
		</div>
	)
}

export default TWInput